import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions, InterviewTypeOptions } from "../../../../../../../../_helpers/Helpers";
import * as actions from "../../../../../_redux/student-pre-interviews/StudentPreInterviewsAction";
import { useInterviewsUIContext } from "../InterviewsUIContext";

const prepareFilter = (queryParams, values) => {
  let { personnelId, interviewType, date, trackingDate, explanation } = values;
  const preInterviewId = queryParams.filter.preInterviewId;
  const newQueryParams = { ...queryParams };
  const filter = { preInterviewId, personnelId, interviewType, date, trackingDate, explanation };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function InterviewsFilter() {
  // Interviews UI Context
  const interviewsUIContext = useInterviewsUIContext();
  const interviewsUIProps = useMemo(() => {
    return {
      queryParams: interviewsUIContext.queryParams,
      setQueryParams: interviewsUIContext.setQueryParams
    };
  }, [interviewsUIContext]);
  
  const dispatch = useDispatch();
  const { currentActiveTerm, personnels } = useSelector(
    (state) => ({
      currentActiveTerm: state.auth.user.currentActiveTerm,
      personnels: state.studentPreInterviews.personnels
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getPersonnels(currentActiveTerm));
  }, [currentActiveTerm, dispatch]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(interviewsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, interviewsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      interviewsUIProps.setQueryParams(newQueryParams);
    }
  };

  const personnelOptions = FilterOptions.concat(personnels);
  const interviewTypeOptions = FilterOptions.concat(InterviewTypeOptions);

  return (
    <Formik
      initialValues={{
        date: "",
        trackingDate: "",
        explanation: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <CustomSelect
                options={personnelOptions}
                value={values.personnelId}
                placeholder="Personel"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("personnelId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Personel</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={interviewTypeOptions}
                value={values.interviewType}
                placeholder="Görüşme Türü"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("interviewType", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Görüşme Türü</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="date"
                className="form-control"
                name="date"
                placeholder="Görüşme Tarihi"
                onBlur={handleBlur}
                value={values.date}
                onChange={(e) => {
                  setFieldValue("date", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Görüşme Tarihi</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="date"
                className="form-control"
                name="trackingDate"
                placeholder="Takip Tarihi"
                onBlur={handleBlur}
                value={values.trackingDate}
                onChange={(e) => {
                  setFieldValue("trackingDate", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Takip Tarihi</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="explanation"
                placeholder="Açıklama"
                onBlur={handleBlur}
                value={values.explanation}
                onChange={(e) => {
                  setFieldValue("explanation", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Açıklama</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}